module.exports = __webpack_public_path__ + "static/media/2@720w.97e480a2.jpg";